<template>
  <div>


<h2 class="goth">Klockan</h2>

<div class="grammatikparagrafbredd leftorient">

<div class="quasi-p">
  När det gäller att uttrycka hur mycket klockan är fungerar tyskan och svenskan väldigt likt.
  <i><b>Över</b></i> heter i klocksammanhang <i><b>nach</b></i> och <i><b>i</b></i> heter <i><b>vor</b></i>.
  <i><b>Kvart</b></i> heter <i><b>Viertel</b></i>. <i><b>Halv</b></i> heter <i><b>halb</b></i> och används på samma sätt som svenskan.
</div>
<div class="quasi-p">
  Vid heltimme, ”prick”, brukar man säga <i><b>Uhr</b></i> efterklockslaget (ungefär som engelskans o’clock).
</div>


<table class="">
<br>

    <tr class="leftorient">
        <td class="ljusgra"><i><b>vor</b></i></td>
        <td class="ljusgra"><i>i</i></td>
    </tr>

    <tr class="leftorient">
      <td class="ljusgra"><i><b>nach</b></i></td>
      <td class="ljusgra"><i>över</i></td>
    </tr>

    <tr class="leftorient">
      <td class="ljusgra"><i><b>halb</b></i></td>
      <td class="ljusgra"><i>halv</i></td>
    </tr>

    <tr class="leftorient">
      <td class="ljusgra"><i><b>Uhr</b></i></td>
      <td class="ljusgra"><i>"o'clock"</i></td>
    </tr>

</table>
<br>
<div class="quasi-p">
När man vill säga <b><i>klockan är.. / hon är … </i></b> säger man <b><i>Es ist …</i></b>

</div>

<div class="ruta">
    <p><i>Es ist fünf Uhr.</i><br> Klockan är fem.</p>

    <p><i>Es ist Viertel nach drei.</i><br>Klockan är kvart över tre.</p>

    <p><i>Es ist Viertel vor vier.</i><br>Klockan är kvart i fyra.</p>

    <p><i>Es ist fünf vor acht.</i><br>Klockan är fem i åtta.</p>

</div>
<br>
<div class="quasi-p">  Men om man vill ange att något skall hända eller hände vid ett speciellt klockslag säger man <b><i>Um..</i></b></div>

<div class="ruta">
    <p><i>Wir sehen uns um zwei Uhr.</i><br>Vi ses klockan två.</p>

    <p><i>Mein freund kommt um halv vier.</i><br>Min vän kommer klockan halv fyra.</p>

    <p><i>Meine Schule endet um Viertel Nach drei.</i><br>Min skola slutar kvar över klockan tre.</p>
</div>

<br><br>
<div class="quasi-p">
Precis som på svenska använder man i talspråk oftast 12-timmarsvarianten alltså att klockan är två på eftermiddagen snarare än 14.

</div>

<div class="quasi-p">
Men man kan också uttrycka sig som en digitalklocka som 11:30 ”elva och trettio”.
I de fallen säger man <b><i>Uhr</i></b> mellan timmen och minuterna.
Och här är det också vanligare att man använder 24-timmars varianten.
</div>


<div class="ruta">
    <p><i>elf Uhr dreißig</i><br>elva och trettio</p>

    <p><i>fünfzehn Uhr zweiundvierzig</i><br>femton och fyrtiotvå</p>
</div>

<br><br>
<div class="quasi-p">
Själva frågan &nbsp;<b>Hur mycket är klockan? </b>&nbsp;brukar ställas på följande sätt
</div>

<div class="ruta">
    <div class="quasi-p"><i>Wie spät ist es?</i><br>Hur mycket är klockan?<br><div class="mindre">bokstavligen "Hur sent är det?"</div></div>

    <div class="quasi-p"><i>Wie viel Uhr ist es?</i><br>Hur mycket är klockan?</div>
</div>
<div class="quasi-p">
Den första varianten är vanligast. Den andra kan uppfattas litet formellare men båda kan användas på samma sätt.
</div>
<br><br>
<div class="quasi-p">Vill man fråga vid vilket klockslag något inträffar använder man frågeordet wann.</div>


<div class="ruta">

    <div class="quasi-p"><i>Wann kommt der Bus?</i><br>När kommer bussen?</div>
</div>





</div>

</div>



</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},
metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "när als wann wenn"
            }
        ]
    }
}

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
